@value mobile from "@shared/styles/breakpoints.module.css";

.root {
  display: block;
}

.title {
  font-family: var(--font-body);
  font-size: var(--type-caption);
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--color-text-muted);
  margin-bottom: clamp(var(--space-14), 2vw, var(--space-24));
}

.head {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-4) var(--space-16);
  margin-bottom: clamp(var(--space-14), 2vw, var(--space-24));

  .title {
    margin-bottom: 0;
  }

  /* На телефоне в одну строку заголовок и пояснение почти касались — пояснение под заголовком */
  @media (max-width: mobile) {
    flex-direction: column;
  }
}

.form {
  display: flex;
  flex-direction: column;
  gap: clamp(var(--space-10), 1.2vw, var(--space-14));
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.label {
  font-size: var(--type-caption);
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.required {
  color: var(--color-primary);
}

.requiredNote {
  font-size: var(--type-caption);
  color: var(--color-text-muted);
  white-space: nowrap;
}

.input {
  display: block;
  width: 100%;
  padding: clamp(var(--space-8), 1vw, var(--space-12))
    clamp(var(--space-10), 1.2vw, var(--space-14));
  /* не меньше 16px: иначе iOS Safari увеличивает страницу при фокусе на поле */
  font-size: 1rem;
  font-family: var(--font-body);
  background: transparent;
  border: 1px solid var(--color-control-border);
  border-radius: var(--radius-small);
  color: var(--color-text);
  transition: border-color var(--motion-fast) ease;

  &:is(textarea) {
    resize: vertical;
    min-height: clamp(80px, 10vw, 120px);
  }
  &:focus {
    outline: none;
    border-color: var(--color-primary);
  }
  &[data-invalid] {
    border-color: var(--color-danger);
  }
}

.consentLabel {
  display: flex;
  align-items: flex-start;
  gap: var(--space-10);
  font-size: var(--type-caption);
  line-height: 1.5;
  color: var(--color-text-muted);
  cursor: pointer;
}

.checkbox {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin-top: var(--space-1);
  padding: 0;
  border: 1px solid var(--color-control-border);
  border-radius: var(--radius-small);
  background: transparent;
  color: var(--color-cta-text-color);
  cursor: pointer;
  transition:
    background var(--motion-fast) ease,
    border-color var(--motion-fast) ease;

  &[data-checked] {
    background: var(--color-primary);
    border-color: var(--color-primary);
  }
  &[data-invalid] {
    border-color: var(--color-danger);
  }
  &:focus-visible {
    outline: 2px solid var(--color-focus);
    outline-offset: 2px;
  }
}

.checkboxIndicator {
  display: flex;

  svg {
    width: 14px;
    height: 14px;
    stroke-width: 3;
  }
}

.fieldError {
  font-size: var(--type-caption);
  color: var(--color-danger);
}

.formError {
  font-size: var(--type-caption);
  color: var(--color-danger);
}

.honeypot {
  position: absolute;
  left: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.submitBtn {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-10);
  width: fit-content;
  padding: clamp(var(--space-11), 1.3vw, var(--space-15)) var(--space-20);
  cursor: pointer;
  border-radius: var(--radius-control);
  min-height: var(--layout-action-height);
  font-family: var(--font-body);
  font-size: var(--type-caption);
  font-weight: 700;
  letter-spacing: normal;
  text-transform: none;

  margin-top: var(--space-4);
  background: var(--color-primary);
  color: var(--color-cta-text-color);
  border: none;
  transition: filter var(--motion-fast) ease;

  @media (hover: hover) and (pointer: fine) {
    &:hover:not(:disabled) {
      filter: brightness(1.08);
    }
  }
  &:disabled {
    cursor: progress;
    opacity: 0.7;
  }
}

.secondaryBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-10);
  width: fit-content;
  padding: clamp(var(--space-11), 1.3vw, var(--space-15)) var(--space-20);
  cursor: pointer;
  border-radius: var(--radius-control);
  min-height: var(--layout-action-height);
  font-family: var(--font-body);
  font-size: var(--type-caption);
  font-weight: 700;
  letter-spacing: normal;
  text-transform: none;

  background: transparent;
  color: var(--color-text);
  border: 1px solid var(--color-control-border);
  transition: border-color var(--motion-fast) ease;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      border-color: var(--color-primary);
    }
  }
}

.sent {
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
}

.sentTitle {
  font-family: var(--font-heading);
  font-size: 1.5rem;
  font-weight: 700;
  text-transform: none;
  color: var(--color-text);
}

.sentText {
  color: var(--color-text-muted);
  margin-bottom: var(--space-8);
}
